import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueGtag from "vue-gtag"
import store from './store'
import i18n from './plugins/i18n'
import vuetify from './plugins/vuetify'

Vue.config.productionTip = false

Vue.use(VueGtag, {
  config: {
    id: 'G-BHFLPFWEE4',
  }
})

new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: h => h(App)
}).$mount('#app')
